import {initProps} from '@/utils/props-formatter'

export default {
    name:"OpenDrawer",
    execute:(action,context)=>{
        const config = JSON.parse(JSON.stringify(action))
        //
        initProps(config,context,context)
        // console.log(config)
        context.drawer.visabled = true
        context.drawer.page = config.params.page
        context.drawer.data = config.params.data||{}
        context.drawer.size = config.params.size||'80%'
        context.drawer.direction = config.params.direction
        context.drawer.title = config.params.title
        context.drawer.name = config.params.name
        context.drawer.injectMethod = {
            close:()=>context.drawer.visabled  = false,
            closeAndLoad:()=>{
                context.drawer.visabled  = false
                context.load()
            }
        }
    }
}